<template>
  <section>
    <div class="container">
      <div class="handle-box">
        <router-link :to="{ path: '/dev/add', query: { id: 0 } }">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="handle-del mr10"
            size="small"
            v-show="ismanager&&!$route.query.dtid"
            >添加</el-button
          >
        </router-link>
        <el-button
          size="small"
          type="primary"
          @click="openDialog()"
          v-show="isadmin"
          >批量导入</el-button
        >
        <el-button size="small" type="primary" @click="exportDevCsv()"
          >批量导出</el-button
        >
        <el-dialog title="批量导入" :visible.sync="dialogUploadVisible">
          <div class="flex-center">
            <el-upload
              class="upload-demo"
              drag
              :action="uploadUrl"
              :headers="headers"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传
                <a href="/template/template.xlsx">&nbsp;模板&nbsp;</a>
                格式的xlsx文件，且不超过500kb
              </div>
            </el-upload>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="closeDialog">确 定</el-button>
          </span>
        </el-dialog>
        <!-- <el-select
          size="small"
          v-model="status"
          default-first-option
          class="handle-select mr10"
          @change="changeStatus()"
        >
          <el-option key="3" label="设备状态" value="3"></el-option>
          <el-option key="2" label="所有设备" value="2"></el-option>
          <el-option key="1" label="在线" value="1"></el-option>
          <el-option key="0" label="离线" value="0"></el-option>
        </el-select> -->
      </div>

      <el-table
        :data="tableData"
        v-loading="loading"
        stripe
        @selection-change="checkIds"
      >
        <!-- @row-dblclick="devDetail" -->
        <el-table-column
          type="selection"
          width="65"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="Guid"
          label="Guid"
          :show-overflow-tooltip="true"
          align="center"
          v-if="false"
        >
        </el-table-column>
        <el-table-column prop="user_name" label="所有者" align="center">
          <div slot-scope="scope">
            {{ scope.row.user_name }}[{{ scope.row.role_name }}]
          </div>
        </el-table-column>
        <el-table-column
          prop="group_name"
          label="所属分组"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="dev_name"
          label="设备名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="dev_code"
          label="设备编号"
          align="center"
        ></el-table-column>
        <el-table-column prop="type_name" label="设备类型" align="center">
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
          :formatter="formatTime"
          width="95"
        ></el-table-column>
        <!-- <el-table-column prop="dev_online_status" label="状态" align="center">
          <div slot-scope="scope">
            <span v-if="String(scope.row.dev_online_status) === '1'">在线</span>
            <span v-else>离线</span>
          </div>
        </el-table-column> -->
        <el-table-column label="变量" align="center">
          <div slot-scope="scope">
            <router-link
              :to="{
                path: '/var/list',
                query: { guid: scope.row.guid }
              }"
              ><a href="javascript:void(0)">变量定义</a></router-link
            >
          </div>
        </el-table-column>
        <el-table-column label="报警" align="center">
          <div slot-scope="scope">
            <router-link
              :to="{ path: '/alarm/list', query: { dtid:$route.query.dtid,guid: scope.row.guid } }"
              ><a href="javascript:void(0)">报警定义</a></router-link
            >
          </div>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <div slot-scope="scope">
            <router-link :to="{ path: '/show', query: { id: scope.row.guid } }">
              <el-button class="ml10" type="text" icon="el-icon-thumb"
                >查看</el-button
              >
            </router-link>
            <router-link
              :to="{ path: '/dev/update', query: { id: scope.row.guid } }"
            >
              <el-button
                class="ml10"
                type="text"
                icon="el-icon-edit"
                v-show="!$route.query.dtid"
                >修改</el-button
              >
              <el-button
                class="ml10"
                type="text"
                icon="el-icon-tickets"
                v-show="$route.query.dtid&&$route.query.dtid!==''"
                >详情</el-button
              >
            </router-link>
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red ml10"
              v-show="!$route.query.dtid"
              @click="deleteDev('Device/Delete', scope.row.guid)"
              >删除</el-button
            >
          </div>
        </el-table-column>

        <el-table-column label="组态" align="center" width="300">
          <div slot-scope="scope">
            <!-- 查看自身的,带有可否启动数据的参数-->
            <router-link
              v-if="scope.row.view_url"
              :to="{
                path: '/viewconf/check',
                query: {
                  cfid: scope.row.view_url,
                  dtid: scope.row.dtid,
                  guid: scope.row.guid,
                  isLive: 1
                }
              }"
            >
              <el-button class="ml10" type="text" icon="el-icon-thumb"
                >查看</el-button
              >
            </router-link>
            <router-link
              v-if="!scope.row.view_url&&!$route.query.dtid"
              :to="{
                path: '/viewconf/add',
                query: {
                  cfid: 0,
                  dtid: scope.row.dtid,
                  guid: scope.row.guid,
                  isLive: 0
                }
              }"
            >
              <el-button class="ml10" type="text" icon="el-icon-edit"
                >创建</el-button
              >
            </router-link>
            <span v-if="!scope.row.view_url&&$route.query.dtid">暂无</span>
            <router-link
              v-if="scope.row.view_url&&!$route.query.dtid"
              :to="{
                path: '/viewconf/update',
                query: {
                  cfid: scope.row.view_url,
                  dtid: scope.row.dtid,
                  guid: scope.row.guid,
                  isLive: 0
                }
              }"
            >
              <el-button class="ml10" type="text" icon="el-icon-edit"
                >编辑</el-button
              >
            </router-link>
            <el-button
              v-if="scope.row.view_url&&!$route.query.dtid"
              type="text"
              icon="el-icon-delete"
              class="red ml10"
              @click="deleteViewConf('ViewConf/Delete', scope.row.view_url)"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>

      <!-- 表格底部 -->
      <div class="cms-list-footer">
        <div class="cms-left">
          <el-button
            size="small"
            :disabled="disabled"
            @click="deleteDev('Device/Delete', ids)"
            >批量删除</el-button
          >
          <el-button
            size="small"
            :disabled="disabled"
            @click="checkBatch('Device/UpdateDevCheck', ids)"
            >批量审核</el-button
          >
        </div>
        <!-- 分页组件 -->
        <cms-pagination :total="total" @change="getPages"></cms-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import listMixins from "@/mixins/list";
import "@/untils/export_csv";

export default {
  name: "Device",
  mixins: [listMixins],
  data() {
    return {
      params: {
        //只需要业务参数
        pageNo: "1",
        pageSize: "10"
      },
      isadmin: false,
      ismanager: false,
      status: "3",
      dialogUploadVisible: false,
      uploadUrl:
        this.$store.state.serverURI +
        "Device/ExcelImport?id=" +
        this.$store.state.userInfo.id,
      headers: {
        Authorization: this.$store.state.token
      },
      checkedList: []
    };
  },
  mounted() {},
  methods: {
    deleteDev(url,ids){
      //删除之前判断有没有自定义变量和报警变量，若有，提示先删除变量，再进行设备删除，
      //1.查询是否存在报警自定义变量和报警变量
      let self=this;
      this.$api.post('Device/IsDelete',{ids:ids})
      .then(res=>{
        if(res.status===200){
          let mess="设备存在自定义变量或报警变量，是否确定删除设备及相关变量？";
          if(res.data.Data==='0'){
            self.deleteBatch(url,ids,mess);
          }
          else{
            self.deleteBatch(url,ids);
          }
        }
      })
    },
    changeStatus() {
      if (this.status == "3") {
        //状态
        return;
      }
      if (this.status == "2") {
        //全部
        this.params.status = "";
        this.initTableData("Device/PagedView", this.params);
      } else {
        this.params.status = this.status;
        this.initTableData("Device/PagedView", this.params);
      }
    },
    checkIds(val) {
      let ids = [];
      for (let i in val) {
        ids.push(val[i].guid);
      }
      this.ids = ids.join(",");
      console.log(this.ids)
      this.disabled = val.length > 0 ? false : true;
      this.checkedList = val;
    },
    openDialog() {
      this.dialogUploadVisible = true;
    },
    closeDialog() {
      this.dialogUploadVisible = false;
    },
    uploadSuccess(response, file, fileList) {
      if (response.indexOf("error") > -1) {
        this.$alert("导入失败:" + response);
      } else {
        this.$alert("成功导入" + response + "条记录");
      }
    },
    uploadError(err, file, fileList) {
      //err.Error.message
      this.$alert("导入失败:" + err.Error.message);
    },
    exportDevCsv() {
      if (this.checkedList.length > 0) {
        this.exportCsv(this.checkedList);
      } else {
        this.$api
          .post("Device", this.params)
          .then(res => {
            if (res.status === 200) {
              let arrs = res.data.Data.list;
              this.exportCsv(arrs);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    exportCsv(data) {
      let fname = "设备" + new Date().getTime();
      let titles = [
        "设备名称",
        "设备编码",
        "设备型号",
        "设备类型",
        "所属用户",
        "设备地址",
        "创建时间",
        "过期时间",
        "精度",
        "纬度"
      ];
      let props = [
        "dev_name",
        "dev_code",
        "dev_no",
        "type_name",
        "user_name",
        "dev_address",
        "create_time",
        "expire_time",
        "dev_lng",
        "dev_lat"
      ];
      JSonToCSV.setDataConver({
        data: data,
        fileName: fname,
        columns: {
          title: titles,
          key: props,
          formatter: function(n, v) {
            //n:列标题属性;;;v:列当前值
            // if(n === 'amont' && !isNaN(Number(v))) {
            //   v = v + '';
            //   v = v.split('.');
            //   v[0] = v[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            //   return v.join('.');
            // }
            // if(n === 'proportion') return v + '%';
            let ret = v;
            if (v) {
              //规避空值
              if (v === "null") {
                ret = v.replace("null", " ");
              }

              if (n.indexOf("time") > -1) {
                //时间处理
                ret = v.replace("T", " ");
              }

              if (
                (n === "dev_name" || n === "dev_code" || n === "dev_no") &&
                !isNaN(v)
              ) {
                ret = "`" + v;
              }
            } else {
              ret = " ";
            }
            return ret;
          }
        }
      });
    },
    formatTime(row, column, cellValue, index) {
      //修正时间格式，形如2018-10-08 11:10:05
      if (cellValue) {
        return cellValue.replace("T", " ").substring(0, 19);
      } else {
        return "";
      }
    }
  },
  created() {
    //获取用户信息
    if (this.$route.query.id) {
      this.params.gid = this.$route.query.id;
    }
    this.params.dtid = this.$route.query.dtid;
    this.params.uid = this.$store.state.userInfo.id;
    this.initTableData("Device/PagedView", this.params);
    this.isadmin = this.$isAdmin();
    this.ismanager = this.$isManager();
  },
  watch: {
    // 修复增改设备之后，重新加载页面，无法执行 created  函数
    $route(to, from) {
      if(to.fullPath.indexOf('/dev/list')===-1)
      {
        return;
      }
      this.params.uid = this.$store.state.userInfo.id;
      this.params.dtid = this.$route.query.dtid;
      this.initTableData("Device/PagedView", this.params);
      this.isadmin = this.$isAdmin();
      this.ismanager = this.$isManager();
    }
  }
};
</script>

<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
